import { RootProps } from '../types/entities';

/**
 *
 * @param args
 * Vanilla web components are restricted to string attributes,
 * while React and Angular can use object literals as arguments
 * 
 * @returns rootClass: for overwriting the default styles of the component
 * @returns attr: attributes which are added to the root element
 */
export const parseRootProps = (args?: RootProps | string): { rootClass?: string; attr: RootProps } => {
  if (!args) {
    return { attr: {} };
  }

  let attr: RootProps;
  if (typeof args === 'string') {
    attr = JSON.parse(args) as RootProps;
  } else {
    attr = {
      ...args, // immutable
    };
  }

  const rootClass = attr.class;
  delete attr.class;
  return { rootClass, attr };
};
